module.exports = __webpack_public_path__ + "img/choose.f76b7b19.svg";